import Plyr from 'plyr';

export function plyr(only) {
    if (only) {
        setVideo(only)
    } else {
        document.querySelectorAll(".plyr").forEach((el) => {
            if (!el.classList.contains("plyr--video")) {
                setVideo(el)
            }
        })
    }

    function setVideo(el) {
        const url = el.dataset.url

        function getIdFromVimeoURL(url) {
            return /(vimeo(pro)?\.com)\/(?:[^\d]+)?(\d+)\??(.*)?$/.exec(url)[3];
        }

        function getIdFromYoutubeURL(url) {
            const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            const match = url.match(regExp);
            return (match && match[7].length == 11) ? match[7] : false;
        }

        if (url.indexOf("vimeo") !== -1) {
            var link = getIdFromVimeoURL(url)
            var provider = "vimeo"
        } else {
            var link = getIdFromYoutubeURL(url)
            var provider = "youtube"
        }

        el.setAttribute("data-plyr-embed-id", link)
        el.setAttribute("data-plyr-provider", provider)

        if(document.querySelector('[data-control=yes]')){
            const player = new Plyr(el, { controls: ['play-large', 'progress', 'volume', 'fullscreen'] },);
        }else {
            const player = new Plyr(el);
        }


    }
}

if(document.querySelector('.plyr')){
    const homeContainerVideos = document.querySelector("#home-videos");
    
    if (homeContainerVideos) {
        let firstLoad = true;
        const marginOffset = 250;
    
        window.addEventListener("scroll", () => {
            const position = homeContainerVideos.getBoundingClientRect().top;
            const windowHeight = window.innerHeight;
    
            if ((position <= windowHeight + marginOffset) && firstLoad) {
                firstLoad = false;
                
                plyr();
            }
        });
    } else {
        plyr();
    }    
}
